<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base"> <!-- AJOUTER OU IMAGE -->
      <vs-avatar style="border: 1px solid;" :text="user.firstname + ' ' + user.lastname" :src="userImage" size="70px" class="mr-4 mb-4" />
      <!-- <div>
        <vs-button class="mr-4 sm:mb-0 mb-2">Upload photo</vs-button>
        <vs-button type="border" color="danger">Remove</vs-button>
        <p class="text-sm mt-2">Format autorisé JPG, GIF ou PNG.</p>
      </div> -->
    </div>
    <div class="flex flex-wrap items-center mb-base">
      <p class="text-sm">{{ user.commentary }}</p>
    </div>

    <!-- Info -->
    <vs-input
      class="w-full mb-base"
      label-placeholder="Prénom"
      v-model="user.firstname"
    ></vs-input>
    <vs-input
      class="w-full mb-base"
      label-placeholder="Nom"
      v-model="user.lastname"
    ></vs-input>
    <vs-input
      class="w-full"
      label-placeholder="Email"
      v-model="user.email"
    ></vs-input>
    <vs-input
      class="w-full my-base"
      label-placeholder="Numéro de téléphone"
      v-model="user.phone"
    ></vs-input>
    <!-- <vs-input
      class="w-full"
      label-placeholder="Url de votre image"
      v-model="user.image_url"
    ></vs-input> -->
    <!-- <vs-input label="Avatar" type="file" name="file" accept="image/*" @change="addImageToPost($event)" /> -->
    <file-pond
      ref="imageUp"
      @addfile="addImageToPost()"
      accepted-file-types="image/jpeg, image/png"
      label-idle="Déposez votre image de profil ici ou cliquez le champ pour l'ajouter (.png ou .jpg seulement)..."/>
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button color="primary" class="ml-auto mt-2" @click="updateUser"
        >Sauvegarder</vs-button
      >
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning"
        >Réinitialiser</vs-button
      > -->
    </div>
  </vx-card>
</template>

<script>
import store from "@/store/store";
import VueCookies from "vue-cookies";
// Import FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";

// Import styles
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);


export default {
	name: "ProfileGeneralUserSettings",
	components: {
		FilePond
	},
	computed: {
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	watch: {
		allCollaboratorsAvatar: function() {
			this.userImage = this.getCollaboratorAvatar(this.user.id);
		},
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			user: null,
			imagetoUpdate: null,
			userImage: null,
			headers: {
				"accept": "application/json",
				"Accept-Language": "en-US,en;q=0.8",
			}
		};
	},
	created() {
		this.user = VueCookies.get("userInfo");
		this.getAllCollaboratorsAvatar();
		this.userImage = this.getCollaboratorAvatar(this.user.id);
	},

	methods: {
		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		addImageToPost(){
			let image = this.$refs.imageUp.getFile();
			let formData = new FormData();
			formData.append("image", image.file);
			this.imagetoUpdate = formData;
		},
		/**
		 * Query the api to update the current user with the given informations
		 */
		updateUser() {
			//console.log("updateUser");
			let param = {
				user: this.user
			};
			this.$http
				.post(this.apiUrl + "users/update", param)
				.then(res => {
					this.user = res.data[0];
					//console.log("user", this.user);
					this.$vs.notify({title: "Profil", text: res.data.msg});
					let oldUserInfo = VueCookies.get("userInfo");
					this.user.userRole = oldUserInfo.userRole;
					VueCookies.set("userInfo", JSON.stringify(res.data[0]));

					if(this.imagetoUpdate){
						this.$http
							.post(this.apiUrl + "users/update/image/" + this.user.id,
								this.imagetoUpdate,
								{
									headers: {
										"accept": "application/json",
										"Accept-Language": "en-US,en;q=0.8",
										"Content-Type": `multipart/form-data; boundary=${this.imagetoUpdate._boundary}`,
									}
								}
							)
							.then(() => {
								this.getAllCollaboratorsAvatar();
								this.$vs.notify({
									title: "Succès",
									text: "Utilisateur modifié avec succès."
								});
							})
							.catch(error => {
								//console.log(error);
								this.$vs.notify({
									title: "Aucune modification",
									text: "L'utilisateur n'a pas été modifié."
								});
							});
					}
				})
				.catch(err => {
					console.error(err);
				});
		},

		/**
		 * Query our API to fetch all the rankwell collaborators avatar
		 */
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},
	}
};
</script>
